module.exports = __webpack_public_path__ + "img/1.12b6f285.png";